import { render, staticRenderFns } from "./dept-form.vue?vue&type=template&id=10410fb6&scoped=true"
import script from "./dept-form.vue?vue&type=script&lang=js"
export * from "./dept-form.vue?vue&type=script&lang=js"
import style0 from "./dept-form.vue?vue&type=style&index=0&id=10410fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10410fb6",
  null
  
)

export default component.exports